(function () {
  if (window.__minicartFreteCupomLoaded) return;
  window.__minicartFreteCupomLoaded = true;

  const CART_URL = () => window.routes?.cart_url || '/cart';
  const CART_UPDATE_URL = () => window.routes?.cart_update_url || '/cart/update';

  const get = (selector) => document.querySelector(selector);
  const byId = (id) => document.getElementById(id);
  const money = (value) =>
    Number(value || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

  function setWaiting(isWaiting) {
    document.querySelectorAll('.minicart-totais').forEach((element) => {
      element.classList.toggle('waiting', isWaiting);
    });
  }

  function showElement(element, display) {
    if (element) element.style.display = display;
  }

  function hideElement(element) {
    if (!element) return;
    element.classList.remove('show');
    element.style.display = 'none';
  }

  function focusLater(element, shouldSelect) {
    window.setTimeout(() => {
      if (!element) return;
      element.focus();
      if (shouldSelect) element.select();
    }, 300);
  }

  function toggleFreteInput() {
    const initialState = byId('frete-initial-state');
    const inputContainer = byId('frete-input-container');

    if (!initialState || !inputContainer) return;

    showElement(initialState, 'none');
    showElement(inputContainer, 'flex');
    inputContainer.classList.add('show');
    focusLater(byId('minicart_billing_cep'));
  }

  function refazerFrete() {
    const inputContainer = byId('frete-input-container');
    if (!inputContainer) return;

    hideElement(byId('frete-error-state'));
    showElement(byId('frete-resultado-state'), 'none');
    showElement(inputContainer, 'flex');
    inputContainer.classList.add('show');
    focusLater(byId('minicart_billing_cep'));
  }

  function mostrarErroFrete() {
    hideElement(byId('frete-initial-state'));
    hideElement(byId('frete-input-container'));

    const errorState = byId('frete-error-state');
    if (!errorState) return;

    showElement(errorState, 'flex');
    window.setTimeout(() => errorState.classList.add('show'), 10);
  }

  function retryFrete() {
    const inputContainer = byId('frete-input-container');
    if (!inputContainer) return;

    hideElement(byId('frete-error-state'));
    showElement(byId('frete-initial-state'), 'none');
    showElement(byId('frete-resultado-state'), 'none');
    showElement(inputContainer, 'flex');

    window.setTimeout(() => {
      inputContainer.classList.add('show');
      focusLater(byId('minicart_billing_cep'), true);
    }, 10);
  }

  function voltarEstadoInicialFrete() {
    const initialState = byId('frete-initial-state');
    const inputContainer = byId('frete-input-container');
    if (!initialState || !inputContainer) return;

    hideElement(inputContainer);
    hideElement(byId('frete-error-state'));
    showElement(byId('frete-resultado-state'), 'none');
    showElement(initialState, 'flex');

    const cepInput = byId('minicart_billing_cep');
    if (cepInput) cepInput.value = '';
  }

  function mostrarResultadoFrete(rates) {
    const listaOpcoes = byId('frete-opcoes-lista');

    hideElement(byId('frete-initial-state'));
    hideElement(byId('frete-input-container'));
    hideElement(byId('frete-error-state'));

    if (listaOpcoes) {
      listaOpcoes.innerHTML = '';
      rates.forEach((rate, index) => {
        const deliveryDays = Array.isArray(rate.delivery_days) && rate.delivery_days.length ? rate.delivery_days[0] : null;
        const prazo = deliveryDays ? `at&eacute; ${deliveryDays} dias &uacute;teis` : 'prazo no checkout';
        const item = document.createElement('div');
        item.className = `frete-opcao-item${index === 0 ? ' selected' : ''}`;
        item.innerHTML = `
          <span class="frete-opcao-nome">${rate.name || 'Frete'}</span>
          <div class="frete-opcao-detalhes">
            <span class="frete-opcao-valor">${money(parseFloat(rate.price))}</span>
            <span class="frete-opcao-prazo">${prazo}</span>
          </div>
        `;
        item.addEventListener('click', () => {
          listaOpcoes.querySelectorAll('.frete-opcao-item').forEach((element) => element.classList.remove('selected'));
          item.classList.add('selected');
          atualizarTotalComFrete(parseFloat(rate.price));
        });
        listaOpcoes.appendChild(item);
      });
    }

    showElement(byId('frete-resultado-state'), 'flex');

    const cepInput = byId('minicart_billing_cep');
    if (cepInput) cepInput.value = '';
  }

  function atualizarTotalComFrete(valorFreteReais) {
    fetch(`${CART_URL()}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const totalValueElement = byId('cart-total-value');
        if (!totalValueElement) return;
        totalValueElement.textContent = money(cart.total_price / 100 + Number(valorFreteReais || 0));
      })
      .catch(() => {});
  }

  function calcular_frete() {
    const cepInput = byId('minicart_billing_cep');
    const postalCode = cepInput ? cepInput.value.replace(/\D/g, '') : '';

    if (!postalCode) {
      if (cepInput) cepInput.focus();
      return;
    }

    setWaiting(true);

    fetch(`https://viacep.com.br/ws/${postalCode}/json/`)
      .then((response) => response.json())
      .then((address) => {
        if (!address || address.erro) throw new Error('CEP invalido');

        const params = new URLSearchParams({
          'shipping_address[zip]': postalCode,
          'shipping_address[country]': 'BR',
          'shipping_address[province]': address.uf || '',
        });

        return fetch(`/cart/shipping_rates.json?${params.toString()}`);
      })
      .then((response) => response.json())
      .then((data) => {
        const rates = Array.isArray(data.shipping_rates) ? data.shipping_rates : [];
        if (!rates.length) {
          mostrarErroFrete();
          return;
        }

        mostrarResultadoFrete(rates);
        atualizarTotalComFrete(parseFloat(rates[0].price));
      })
      .catch(() => {
        mostrarErroFrete();
      })
      .finally(() => {
        setWaiting(false);
      });
  }

  function toggleCupomInput() {
    const initialState = byId('cupom-initial-state');
    const inputContainer = byId('cupom-input-container');
    if (!initialState || !inputContainer) return;

    showElement(initialState, 'none');
    showElement(inputContainer, 'flex');
    inputContainer.classList.add('show');
    focusLater(byId('minicart_billing_coupon'));
  }

  function atualizarTotaisCarrinho() {
    fetch(`${CART_URL()}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const totalValueElement = byId('cart-total-value');
        if (totalValueElement) totalValueElement.textContent = money(cart.total_price / 100);
      })
      .catch(() => {});
  }

  function syncCupomUIFromCart(cart) {
    const initialState = byId('cupom-initial-state');
    const appliedState = byId('cupom-applied-state');
    const inputContainer = byId('cupom-input-container');
    const errorState = byId('cupom-error-state');
    const appliedCode = byId('cupom-applied-code');
    const validationEl = byId('cupom-applied-validation');
    const codeInput = byId('minicart_billing_coupon');

    if (!initialState || !appliedState) return;

    hideElement(inputContainer);
    hideElement(errorState);

    const appliedDiscount = cart?.discount_codes?.find((discount) => discount.applicable === true || discount.applicable === undefined);
    if (appliedDiscount) {
      if (appliedCode) appliedCode.textContent = appliedDiscount.code.toUpperCase();
      if (validationEl && cart.total_discount != null && cart.total_discount > 0) {
        validationEl.textContent = `-${money(cart.total_discount / 100)}`;
      }
      showElement(appliedState, 'flex');
      showElement(initialState, 'none');
    } else {
      if (validationEl) validationEl.textContent = '';
      showElement(appliedState, 'none');
      showElement(initialState, 'flex');
    }

    if (codeInput) codeInput.value = '';
  }

  function reRenderCartDrawerFromSection(cartData) {
    const cartUrl = CART_URL();
    const sectionUrl = `${cartUrl}${cartUrl.includes('?') ? '&' : '?'}section_id=cart-drawer`;

    fetch(sectionUrl, { headers: { Accept: 'text/html' } })
      .then((response) => response.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        const newInner = doc.querySelector('cart-drawer .drawer__inner');
        const currentInner = get('cart-drawer .drawer__inner');
        if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;

        if (cartData) {
          syncCupomUIFromCart(cartData);
        } else {
          fetch(`${cartUrl}.js`)
            .then((response) => response.json())
            .then(syncCupomUIFromCart)
            .catch(() => {});
        }

        document.body.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch((error) => {
        console.error('Erro ao atualizar mini cart:', error);
        if (cartData) syncCupomUIFromCart(cartData);
      });
  }

  function voltarEstadoInicialCupom(codigo) {
    const initialState = byId('cupom-initial-state');
    const appliedState = byId('cupom-applied-state');
    const inputContainer = byId('cupom-input-container');
    const errorState = byId('cupom-error-state');
    const appliedCode = byId('cupom-applied-code');
    const inserirLink = get('.cupom-initial-state .inserir-codigo-link');

    if (!initialState || !inputContainer) return;

    hideElement(inputContainer);
    hideElement(errorState);

    if (codigo && appliedState && appliedCode) {
      appliedCode.textContent = codigo.toUpperCase();
      showElement(appliedState, 'flex');
      showElement(initialState, 'none');
    } else {
      showElement(appliedState, 'none');
      showElement(initialState, 'flex');
      if (inserirLink) inserirLink.style.display = '';
    }

    const codeInput = byId('minicart_billing_coupon');
    if (codeInput) codeInput.value = '';

    atualizarTotaisCarrinho();
  }

  function mostrarErroCupom(mensagem) {
    const initialState = byId('cupom-initial-state');
    const appliedState = byId('cupom-applied-state');
    const inputContainer = byId('cupom-input-container');
    const errorState = byId('cupom-error-state');
    const errorMsg = byId('cupom-error-message');
    const errorInput = byId('minicart_billing_coupon_error');
    const originalInput = byId('minicart_billing_coupon');

    if (!errorState) return;

    if (errorInput && originalInput) errorInput.value = originalInput.value;
    if (errorMsg) errorMsg.textContent = mensagem || 'N\u00e3o \u00e9 um cupom v\u00e1lido :(';

    showElement(initialState, 'none');
    showElement(appliedState, 'none');
    hideElement(inputContainer);
    showElement(errorState, 'flex');
    window.setTimeout(() => errorState.classList.add('show'), 10);
  }

  function retryCupom() {
    const inputContainer = byId('cupom-input-container');
    const errorState = byId('cupom-error-state');
    const errorInput = byId('minicart_billing_coupon_error');
    const couponInput = byId('minicart_billing_coupon');

    if (!errorState || !inputContainer) return;

    if (couponInput && errorInput) couponInput.value = errorInput.value;

    hideElement(errorState);
    showElement(byId('cupom-initial-state'), 'none');
    showElement(inputContainer, 'flex');

    window.setTimeout(() => {
      inputContainer.classList.add('show');
      focusLater(couponInput, true);
    }, 10);
  }

  function aplicarCupomMinicart() {
    const codeInput = byId('minicart_billing_coupon');
    const code = codeInput ? codeInput.value.trim() : '';

    if (!code) {
      mostrarErroCupom('Digite o c\u00f3digo do cupom.');
      if (codeInput) codeInput.focus();
      return;
    }

    if (code.length < 2) {
      mostrarErroCupom('C\u00f3digo do cupom inv\u00e1lido.');
      if (codeInput) codeInput.focus();
      return;
    }

    fetch(`${CART_UPDATE_URL()}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code }),
    })
      .then((response) =>
        response.json().then((data) => ({
          ok: response.ok,
          data,
        }))
      )
      .then((result) => {
        if (!result.ok) {
          mostrarErroCupom(result.data?.description || result.data?.message || 'Cupom inv\u00e1lido. Tente outro c\u00f3digo.');
          return;
        }

        const applied = result.data?.discount_codes?.some((discount) => discount.applicable === true || discount.applicable === undefined);
        if (applied) {
          reRenderCartDrawerFromSection(result.data);
        } else {
          mostrarErroCupom('Este cupom n\u00e3o se aplica ao seu carrinho ou j\u00e1 expirou.');
        }
      })
      .catch(() => {
        mostrarErroCupom('Erro ao aplicar cupom. Verifique sua conex\u00e3o e tente novamente.');
      });
  }

  function removerCupomMinicart() {
    fetch(`${CART_UPDATE_URL()}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' }),
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then((result) => {
        reRenderCartDrawerFromSection(result.data);
      })
      .catch(() => {
        voltarEstadoInicialCupom(null);
      });
  }

  function inicializarCupomAplicado() {
    fetch(`${CART_URL()}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const appliedDiscount = cart.discount_codes?.find((discount) => discount.applicable !== false);
        if (appliedDiscount) voltarEstadoInicialCupom(appliedDiscount.code);
      })
      .catch(() => {});
  }

  function initCupomObserver() {
    const cartDrawer = get('cart-drawer');
    if (!cartDrawer || cartDrawer.__minicartCupomObserver) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class' && cartDrawer.classList.contains('active')) {
          window.setTimeout(inicializarCupomAplicado, 300);
        }
      });
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
    });

    cartDrawer.__minicartCupomObserver = observer;

    if (cartDrawer.classList.contains('active')) inicializarCupomAplicado();
  }

  function initCartRefreshListener() {
    if (document.body.__minicartCupomRefreshListener) return;
    document.body.__minicartCupomRefreshListener = true;
    document.body.addEventListener('cart:refresh', () => {
      window.setTimeout(inicializarCupomAplicado, 500);
    });
  }

  window.toggleFreteInput = toggleFreteInput;
  window.refazerFrete = refazerFrete;
  window.calcular_frete = calcular_frete;
  window.mostrarResultadoFrete = mostrarResultadoFrete;
  window.voltarEstadoInicialFrete = voltarEstadoInicialFrete;
  window.mostrarErroFrete = mostrarErroFrete;
  window.retryFrete = retryFrete;
  window.toggleCupomInput = toggleCupomInput;
  window.atualizarTotaisCarrinho = atualizarTotaisCarrinho;
  window.syncCupomUIFromCart = syncCupomUIFromCart;
  window.reRenderCartDrawerFromSection = reRenderCartDrawerFromSection;
  window.voltarEstadoInicialCupom = voltarEstadoInicialCupom;
  window.mostrarErroCupom = mostrarErroCupom;
  window.retryCupom = retryCupom;
  window.aplicarCupomMinicart = aplicarCupomMinicart;
  window.removerCupomMinicart = removerCupomMinicart;
  window.inicializarCupomAplicado = inicializarCupomAplicado;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCupomObserver();
      initCartRefreshListener();
    });
  } else {
    initCupomObserver();
    initCartRefreshListener();
  }
})();
